import { render, staticRenderFns } from "./ContractSetup.vue?vue&type=template&id=f7249354&scoped=true&"
import script from "./ContractSetup.vue?vue&type=script&lang=js&"
export * from "./ContractSetup.vue?vue&type=script&lang=js&"
import style0 from "./ContractSetup.vue?vue&type=style&index=0&id=f7249354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7249354",
  null
  
)

export default component.exports